import { Component, OnInit } from '@angular/core';
import { LoadingService } from '@services/loading/loading.service';
import { AuctionService } from '@services/auction/auction.service';
import moment from 'moment';
import { environment } from 'environments/environment';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
@Component({
  selector: 'app-auction-car-list',
  templateUrl: './auction-car-list.component.html',
  styleUrls: ['./auction-car-list.component.scss'],
})
export class AuctionCarListComponent implements OnInit {
  public allProductList: any[] = [];
  public allGroupAuctionList: any[] = [];
  public isLogin: boolean = true;
  public loading: boolean = false;
  public getCurrentDate: any;
  private _opened: boolean = false;
  public getMonth: any;
  public allFutureProductList: any[] = [];
  public allTodaysLiveProductList: any[] = [];
  public allTodaysInitialLiveProductList: any[] = [];
  public todayFutureProductList: any[] = [];
  public env = environment.forntend_url;
  public liveAuctionTimer: any;
  public allBulkProductList: any[] = [];
  public allBulkGroupAuctionList: any[] = [];
  public allBulkFutureProductList: any[] = [];
  public allBulkTodaysLiveProductList: any[] = [];
  public allBulkTodaysInitialLiveProductList: any[] = [];
  public todayBulkFutureProductList: any[] = [];
  public producInfotList: any[] = [];
  public hour: any;
  public min: any;
  public initialhour: any;
  public initialmin: any;
  // public liveAuctionStartIndicator: boolean = false;
  // public liveAuctionStartAfterIndicator: boolean = false;
  public allAuctionData: any;
  // public auction_list = auction_list

  constructor(
    public auctionService: AuctionService,
    public loader: LoadingService,
    public router: Router
  ) {
    // this.getAuctionLists();
  }

  ngOnInit(): void {}

  getAuctionLists() {
    this.loading = true;
    this.auctionService.getAuctionList().subscribe(
      (res: any) => {
        // clearInterval(this.liveAuctionTimer)

        let data = res['data'];
        this.allAuctionData = res['data'];
        // Set Time Interval for watch the live auction Update without reload the browser
        // this.liveAuctionTimer = setInterval(() => {

        this.allProductList = [];
        this.allFutureProductList = [];
        this.allTodaysLiveProductList = [];
        this.allTodaysInitialLiveProductList = [];
        this.allGroupAuctionList = [];
        this.todayFutureProductList = [];
        this.allBulkProductList = [];
        this.allBulkFutureProductList = [];
        this.allBulkTodaysLiveProductList = [];
        this.allBulkTodaysInitialLiveProductList = [];
        this.allBulkGroupAuctionList = [];
        this.todayBulkFutureProductList = [];
        this.producInfotList = [];

        for (let object of data) {
          // localStorage.setItem('productInfo', JSON.stringify(object['ProductInfo']));
          if (object['entity_type'] === 'individual') {
            let getAuctionDate = Number(
              object['live_auction_start_date_time'].split(',')[0].split('-')[0]
            );
            let getAuctionMonth = Number(
              object['live_auction_start_date_time'].split(',')[0].split('-')[1]
            );

            // let getAuctionStartHour = Number(object['live_auction_start_date_time'].split(",")[1].trim().split(":")[0]) + 12;
            // let getAuctionStartMin = object['live_auction_start_date_time'].split(",")[1].split(":")[1];
            // let getAuctionEndHour = Number(object['live_auction_end_date_time'].split(",")[1].trim().split(":")[0]) + 12;
            // let getAuctionEndMin =  object['live_auction_end_date_time'].split(",")[1].trim().split(":")[1];

            //Start
            let getDateInFormat = new Date();
            let getCurrentMonth = Number(moment(getDateInFormat).format('MM'));
            let getCurrentDate = Number(moment(getDateInFormat).format('DD'));
            // let getCurrentHour = Number(moment(getDateInFormat).format('hh')) + 12;
            // let getCurrentMin = moment(getDateInFormat).format('mm');

            let getCurrentHour: any = moment(getDateInFormat).format('hh');
            let getCurrentMin: any = moment(getDateInFormat).format('mm');
            let getCurrentHourInMin =
              Number(getCurrentHour) * 60 + Number(getCurrentMin);
            // let getCurrentHourMin: any = moment(getDateInFormat).format('h:mm');
            let getCurrentHourMin: any = Number(getCurrentHourInMin);

            let getAuctionStartTimeHour = Number(
              object['live_auction_start_date_time'].split(',')[1].split(':')[0]
            );
            let getAuctionStartTimeMin = Number(
              object['live_auction_start_date_time'].split(',')[1].split(':')[1]
            );

            let getAuctionEndTimeHour = Number(
              object['live_auction_end_date_time'].split(',')[1].split(':')[0]
            );
            let getAuctionEndTimeMin = Number(
              object['live_auction_end_date_time'].split(',')[1].split(':')[1]
            );

            let getAuctionStartHourMins =
              getAuctionStartTimeHour * 60 + getAuctionStartTimeMin;
            let getAuctionEndHourMins =
              getAuctionEndTimeHour * 60 + getAuctionEndTimeMin;

            // let getAuctionStartHourMins = object['live_auction_start_date_time'].split(",")[1].split(":")[0] + ':' + object['live_auction_start_date_time'].split(",")[1].split(":")[1];
            // let getAuctionEndHourMins = object['live_auction_end_date_time'].split(",")[1].split(":")[0] + ':' + object['live_auction_end_date_time'].split(",")[1].split(":")[1];

            let getInitialAuctionDate = Number(
              object['auction_start_date_time'].split(',')[0].split('-')[0]
            );
            let getInitialAuctionMonth = Number(
              object['auction_start_date_time'].split(',')[0].split('-')[1]
            );

            let getInitialAuctionStartTimeHour = Number(
              object['auction_start_date_time'].split(',')[1].split(':')[0]
            );
            let getInitialAuctionStartTimeMin = Number(
              object['auction_start_date_time'].split(',')[1].split(':')[1]
            );

            let getInitialAuctionStartHourMins =
              getInitialAuctionStartTimeHour * 60 +
              getInitialAuctionStartTimeMin;

            // END
            if (getCurrentMonth > getAuctionMonth) {
              // PAST AUCTION
              this.allProductList.push({
                image:
                  object?.imageUrl == null
                    ? ''
                    : object?.imageUrl[0]?.presigned_url,
                carName:
                  object['description_data']['Model Year'] +
                  ' ' +
                  object['description_data']['Model'] +
                  ' ' +
                  object['description_data']['Interior Colour'],
                auctionStartTime:
                  object['live_auction_start_date_time'].split(',')[1],
                auctionStartDate:
                  object['live_auction_start_date_time'].split(',')[0],
                buyNowPrice: object['buy_now_price'],
                currentPreBid: object['HighestBid'],
                financing: '--',
                auctionId: object['auction_id'],
                productid: object['product_id'],
              });
            } else {
              if (
                getAuctionDate > getCurrentDate &&
                getAuctionMonth >= getCurrentMonth
              ) {
                // FUTURE DATE AUCTION
                this.allFutureProductList.push({
                  image:
                    object?.imageUrl == null
                      ? ''
                      : object?.imageUrl[0]?.presigned_url,
                  carName:
                    object['description_data']['Model Year'] +
                    ' ' +
                    object['description_data']['Model'] +
                    ' ' +
                    object['description_data']['Interior Colour'],
                  auctionStartTime:
                    object['live_auction_start_date_time'].split(',')[1],
                  auctionStartDate:
                    object['live_auction_start_date_time'].split(',')[0],
                  buyNowPrice: object['buy_now_price'],
                  currentPreBid: object['HighestBid'],
                  financing: '--',
                  auctionId: object['auction_id'],
                  productid: object['product_id'],
                });
              } else if (getAuctionDate == getCurrentDate) {
                // TODAYS AUCTION or Live Auction
                if (
                  getAuctionStartHourMins <= getCurrentHourMin &&
                  object['auction_status_id'] === null
                ) {
                  this.allTodaysLiveProductList.push({
                    image:
                      object?.imageUrl == null
                        ? ''
                        : object?.imageUrl[0]?.presigned_url,
                    carName:
                      object?.description_data['Model Year'] +
                      ' ' +
                      object?.description_data['Model'] +
                      ' ' +
                      object?.description_data['Interior Colour'],
                    auctionStartTime:
                      object['live_auction_start_date_time'].split(',')[1],
                    auctionStartDate:
                      object['live_auction_start_date_time'].split(',')[0],
                    buyNowPrice: object['buy_now_price'],
                    currentPreBid: object['HighestBid'],
                    financing: '--',
                    auctionId: object['auction_id'],
                    productid: object['product_id'],
                    auction_status_id: object['auction_status_id']
                      ? object['auction_status_id']
                      : null,
                  });
                } else if (
                  getInitialAuctionStartHourMins <= getCurrentHourMin
                ) {
                  this.allTodaysInitialLiveProductList.push({
                    image:
                      object?.imageUrl == null
                        ? ''
                        : object?.imageUrl[0]?.presigned_url,
                    carName:
                      object?.description_data['Model Year'] +
                      ' ' +
                      object?.description_data['Model'] +
                      ' ' +
                      object?.description_data['Interior Colour'],
                    auctionStartTime:
                      object['auction_start_date_time'].split(',')[1],
                    auctionStartDate:
                      object['auction_start_date_time'].split(',')[0],
                    buyNowPrice: object['buy_now_price'],
                    currentPreBid: object['HighestBid'],
                    financing: '--',
                    auctionId: object['auction_id'],
                    productid: object['product_id'],
                  });
                } else if (getAuctionStartHourMins > getCurrentHourMin) {
                  //Today's Future Auction
                  this.todayFutureProductList.push({
                    image:
                      object?.imageUrl == null
                        ? ''
                        : object?.imageUrl[0]?.presigned_url,
                    carName:
                      object['description_data']['Model Year'] +
                      ' ' +
                      object['description_data']['Model'] +
                      ' ' +
                      object['description_data']['Interior Colour'],
                    auctionStartTime:
                      object['live_auction_start_date_time'].split(',')[1],
                    auctionStartDate:
                      object['live_auction_start_date_time'].split(',')[0],
                    buyNowPrice: object['buy_now_price'],
                    currentPreBid: object['HighestBid'],
                    financing: '--',
                    auctionId: object['auction_id'],
                    productid: object['product_id'],
                  });
                }
              } else if (getAuctionStartHourMins > getCurrentHourMin) {
                this.todayFutureProductList.push({
                  image:
                    object?.imageUrl == null
                      ? ''
                      : object?.imageUrl[0]?.presigned_url,
                  carName:
                    object['description_data']['Model Year'] +
                    ' ' +
                    object['description_data']['Model'] +
                    ' ' +
                    object['description_data']['Interior Colour'],
                  auctionStartTime:
                    object['live_auction_start_date_time'].split(',')[1],
                  auctionStartDate:
                    object['live_auction_start_date_time'].split(',')[0],
                  buyNowPrice: object['reserve_price'],
                  currentPreBid: object['HighestBid'],
                  financing: '--',
                  auctionId: object['auction_id'],
                  productid: object['product_id'],
                });
              }
            }
          } else if (
            object['entity_type'] === 'group' &&
            object['auction_type'] === '1'
          ) {
            // this.allGroupAuctionList.push(object);
            let getAuctionDate = Number(
              object['live_auction_start_date_time'].split(',')[0].split('-')[0]
            );
            let getAuctionMonth = Number(
              object['live_auction_start_date_time'].split(',')[0].split('-')[1]
            );

            let getinitialAuctionDate = Number(
              object['auction_start_date_time'].split(',')[0].split('-')[0]
            );
            let getinitialAuctionMonth = Number(
              object['auction_start_date_time'].split(',')[0].split('-')[1]
            );

            //Start
            let getDateInFormat = new Date();

            let getCurrentMonth = Number(moment(getDateInFormat).format('MM'));
            let getCurrentDate = Number(moment(getDateInFormat).format('DD'));

            let getCurrentHour: any = moment(getDateInFormat).format('HH');
            let getCurrentMin: any = moment(getDateInFormat).format('mm');

            let getCurrentHourInMin =
              Number(getCurrentHour) * 60 + Number(getCurrentMin);
            let getCurrentHourMin: any = Number(getCurrentHourInMin);

            // let getAuctionStartTimeHour = Number(object['live_auction_start_date_time'].split(",")[1].split(":")[0]) ;
            // let getAuctionStartTimeMin = Number(object['live_auction_start_date_time'].split(",")[1].split(":")[1]);

            let getAuctionStartTimeHour = Number(
              object['live_auction_start_date_time'].split(',')[1].split(':')[0]
            );
            let getAuctionStartTimeMin = Number(
              object['live_auction_start_date_time'].split(',')[1].split(':')[0]
            );

            let getInitialAuctionStartTimeHour = Number(
              object['auction_start_date_time'].split(',')[1].split(':')[0]
            );
            let getInitialAuctionStartTimeMin = Number(
              object['auction_start_date_time'].split(',')[1].split(':')[0]
            );

            var live_auctionTime;
            if (
              object['live_auction_start_date_time'].split(',')[1].match('PM')
            ) {
              this.hour =
                Number(
                  object['live_auction_start_date_time']
                    .split(',')[1]
                    .split(':')[0]
                ) + 12;
              this.min = Number(
                object['live_auction_start_date_time']
                  .split(',')[1]
                  .split(':')[1]
              );
            } else {
              this.hour = Number(
                object['live_auction_start_date_time']
                  .split(',')[1]
                  .split(':')[0]
              );
              this.min = Number(
                object['live_auction_start_date_time']
                  .split(',')[1]
                  .split(':')[1]
              );
            }

            var initial_auctionTime;
            if (object['auction_start_date_time'].split(',')[1].match('PM')) {
              this.initialhour =
                Number(
                  object['auction_start_date_time'].split(',')[1].split(':')[0]
                ) + 12;
              this.initialmin = Number(
                object['auction_start_date_time'].split(',')[1].split(':')[1]
              );
            } else {
              this.initialhour = Number(
                object['auction_start_date_time'].split(',')[1].split(':')[0]
              );
              this.initialmin = Number(
                object['auction_start_date_time'].split(',')[1].split(':')[1]
              );
            }

            let getAuctionEndTimeHour = Number(
              object['live_auction_end_date_time'].split(',')[1].split(':')[0]
            );
            let getAuctionEndTimeMin = Number(
              object['live_auction_end_date_time'].split(',')[1].split(':')[1]
            );

            // let getAuctionStartHourMins = getAuctionStartTimeHour * 60 + getAuctionStartTimeMin;
            let getAuctionStartHourMins = this.hour * 60 + this.min;

            let getInitialAuctionStartHourMins =
              this.initialhour * 60 + this.initialmin;

            let getAuctionEndHourMins =
              getAuctionEndTimeHour * 60 + getAuctionEndTimeMin;

            if (getCurrentMonth > getAuctionMonth) {
              // PAST AUCTION
              this.allBulkProductList.push({
                image:
                  object['bulkInfo'][0]['BatchImageUrl'] == null
                    ? ''
                    : object['bulkInfo'][0]['BatchImageUrl'][0][
                        'presigned_url'
                      ],
                carName: object['title'],
                auctionStartTime:
                  object['live_auction_start_date_time'].split(',')[1],
                auctionStartDate:
                  object['live_auction_start_date_time'].split(',')[0],
                buyNowPrice: object['reserve_price'],
                currentPreBid: object['HighestBid'],
                financing: '--',
                auctionId: object['auction_id'],
                productid:
                  Object.keys(object['bulkInfo']).length == null
                    ? ' '
                    : Object.keys(object['bulkInfo']).length,
                auction_type: object['auction_type'],
                productinfo: object['ProductInfo'],
                auctionType: object['auction_type'],
              });
            } else {
              if (
                getAuctionDate > getCurrentDate &&
                getAuctionMonth >= getCurrentMonth
              ) {
                // FUTURE DATE AUCTION
                this.allBulkFutureProductList.push({
                  image:
                    object['bulkInfo'][0]['BatchImageUrl'] == null
                      ? ''
                      : object['bulkInfo'][0]['BatchImageUrl'][0][
                          'presigned_url'
                        ],
                  carName: object['title'],
                  auctionStartTime:
                    object['live_auction_start_date_time'].split(',')[1],
                  auctionStartDate:
                    object['live_auction_start_date_time'].split(',')[0],
                  buyNowPrice: object['reserve_price'],
                  currentPreBid: object['HighestBid'],
                  financing: '--',
                  auctionId: object['auction_id'],
                  productid:
                    Object.keys(object['bulkInfo']).length == null
                      ? ' '
                      : Object.keys(object['bulkInfo']).length,
                  auction_type: object['auction_type'],
                  productinfo: object['ProductInfo'],
                  auctionType: object['auction_type'],
                });
              } else if (getAuctionDate == getCurrentDate) {
                // TODAYS AUCTION or Live Auction
                if (getAuctionStartHourMins <= getCurrentHourMin) {
                  this.allBulkTodaysLiveProductList.push({
                    image:
                      object['bulkInfo'][0]['BatchImageUrl'] == null
                        ? ''
                        : object['bulkInfo'][0]['BatchImageUrl'][0][
                            'presigned_url'
                          ],
                    carName: object['title'],
                    auctionStartTime:
                      object['live_auction_start_date_time'].split(',')[1],
                    auctionStartDate:
                      object['live_auction_start_date_time'].split(',')[0],
                    buyNowPrice: object['reserve_price'],
                    currentPreBid: object['HighestBid'],
                    financing: '--',
                    auctionId: object['auction_id'],
                    productid:
                      Object.keys(object['bulkInfo']).length == null
                        ? ' '
                        : Object.keys(object['bulkInfo']).length,
                    auction_type: object['auction_type'],
                    productinfo: object['ProductInfo'],
                    auctionType: object['auction_type'],
                    auction_status_id: object['auction_status_id']
                      ? object['auction_status_id']
                      : null,
                  });
                } else if (
                  getInitialAuctionStartHourMins <= getCurrentHourMin
                ) {
                  this.allBulkTodaysInitialLiveProductList.push({
                    image:
                      object['bulkInfo'][0]['BatchImageUrl'] == null
                        ? ''
                        : object['bulkInfo'][0]['BatchImageUrl'][0][
                            'presigned_url'
                          ],
                    carName: object['title'],
                    auctionStartTime:
                      object['auction_start_date_time'].split(',')[1],
                    auctionStartDate:
                      object['auction_start_date_time'].split(',')[0],
                    buyNowPrice: object['reserve_price'],
                    currentPreBid: object['HighestBid'],
                    financing: '--',
                    auctionId: object['auction_id'],
                    productid:
                      Object.keys(object['bulkInfo']).length == null
                        ? ' '
                        : Object.keys(object['bulkInfo']).length,
                    auction_type: object['auction_type'],
                    productinfo: object['ProductInfo'],
                    auctionType: object['auction_type'],
                  });
                } else if (getAuctionStartHourMins > getCurrentHourMin) {
                  //Today's Future Auction
                  this.todayBulkFutureProductList.push({
                    image:
                      object['bulkInfo'][0]['BatchImageUrl'] == null
                        ? ''
                        : object['bulkInfo'][0]['BatchImageUrl'][0][
                            'presigned_url'
                          ],
                    carName: object['title'],
                    auctionStartTime:
                      object['live_auction_start_date_time'].split(',')[1],
                    auctionStartDate:
                      object['live_auction_start_date_time'].split(',')[0],
                    buyNowPrice: object['reserve_price'],
                    currentPreBid: object['HighestBid'],
                    financing: '--',
                    auctionId: object['auction_id'],
                    productid:
                      Object.keys(object['bulkInfo']).length == null
                        ? ' '
                        : Object.keys(object['bulkInfo']).length,
                    auction_type: object['auction_type'],
                    productinfo: object['ProductInfo'],
                    auctionType: object['auction_type'],
                  });
                }
              } else if (getAuctionStartHourMins > getCurrentHourMin) {
                this.todayBulkFutureProductList.push({
                  image:
                    object['bulkInfo'][0]['BatchImageUrl'] == null
                      ? ''
                      : object['bulkInfo'][0]['BatchImageUrl'][0][
                          'presigned_url'
                        ],
                  carName: object['title'],
                  auctionStartTime:
                    object['live_auction_start_date_time'].split(',')[1],
                  auctionStartDate:
                    object['live_auction_start_date_time'].split(',')[0],
                  buyNowPrice: object['reserve_price'],
                  currentPreBid: object['HighestBid'],
                  financing: '--',
                  auctionId: object['auction_id'],
                  productid:
                    Object.keys(object['bulkInfo']).length == null
                      ? ' '
                      : Object.keys(object['bulkInfo']).length,
                  auction_type: object['auction_type'],
                  productinfo: object['ProductInfo'],
                  auctionType: object['auction_type'],
                });
              }
            }
          } else if (
            object['entity_type'] === 'group' &&
            object['auction_type'] === '0'
          ) {
            // this.allGroupAuctionList.push(object);
            let getAuctionDate = Number(
              object['live_auction_start_date_time'].split(',')[0].split('-')[0]
            );
            let getAuctionMonth = Number(
              object['live_auction_start_date_time'].split(',')[0].split('-')[1]
            );

            //Start
            let getDateInFormat = new Date();

            let getCurrentMonth = Number(moment(getDateInFormat).format('MM'));
            let getCurrentDate = Number(moment(getDateInFormat).format('DD'));

            let getCurrentHour: any = moment(getDateInFormat).format('HH');
            let getCurrentMin: any = moment(getDateInFormat).format('mm');

            let getCurrentHourInMin =
              Number(getCurrentHour) * 60 + Number(getCurrentMin);
            let getCurrentHourMin: any = Number(getCurrentHourInMin);

            // let getAuctionStartTimeHour = Number(object['live_auction_start_date_time'].split(",")[1].split(":")[0]) ;
            // let getAuctionStartTimeMin = Number(object['live_auction_start_date_time'].split(",")[1].split(":")[1]);

            let getAuctionStartTimeHour = Number(
              object['live_auction_start_date_time'].split(',')[1].split(':')[0]
            );
            let getAuctionStartTimeMin = Number(
              object['live_auction_start_date_time'].split(',')[1].split(':')[0]
            );

            var live_auctionTime;
            if (
              object['live_auction_start_date_time'].split(',')[1].match('PM')
            ) {
              this.hour =
                Number(
                  object['live_auction_start_date_time']
                    .split(',')[1]
                    .split(':')[0]
                ) + 12;
              this.min = Number(
                object['live_auction_start_date_time']
                  .split(',')[1]
                  .split(':')[1]
              );
            } else {
              this.hour = Number(
                object['live_auction_start_date_time']
                  .split(',')[1]
                  .split(':')[0]
              );
              this.min = Number(
                object['live_auction_start_date_time']
                  .split(',')[1]
                  .split(':')[1]
              );
            }

            let getAuctionEndTimeHour = Number(
              object['live_auction_end_date_time'].split(',')[1].split(':')[0]
            );
            let getAuctionEndTimeMin = Number(
              object['live_auction_end_date_time'].split(',')[1].split(':')[1]
            );

            // let getAuctionStartHourMins = getAuctionStartTimeHour * 60 + getAuctionStartTimeMin;
            let getAuctionStartHourMins = this.hour * 60 + this.min;

            let getAuctionEndHourMins =
              getAuctionEndTimeHour * 60 + getAuctionEndTimeMin;

            if (getCurrentMonth > getAuctionMonth) {
              // PAST AUCTION
              this.allBulkProductList.push({
                image:
                  object['BatchImageUrl'] == null
                    ? ''
                    : object['BatchImageUrl'][0]['presigned_url'],
                carName: object['title'],
                auctionStartTime:
                  object['live_auction_start_date_time'].split(',')[1],
                auctionStartDate:
                  object['live_auction_start_date_time'].split(',')[0],
                buyNowPrice: object['reserve_price'],
                currentPreBid: object['HighestBid'],
                financing: '--',
                auctionId: object['auction_id'],
                productid:
                  Object.keys(object['product_id']).length == null
                    ? ' '
                    : Object.keys(object['product_id']).length,
                auction_type: object['auction_type'],
                productinfo: object['ProductInfo'],
                auctionType: object['auction_type'],
              });
            } else {
              if (
                getAuctionDate > getCurrentDate &&
                getAuctionMonth >= getCurrentMonth
              ) {
                // FUTURE DATE AUCTION
                this.allBulkFutureProductList.push({
                  image:
                    object['BatchImageUrl'] == null
                      ? ''
                      : object['BatchImageUrl'][0]['presigned_url'],
                  carName: object['title'],
                  auctionStartTime:
                    object['live_auction_start_date_time'].split(',')[1],
                  auctionStartDate:
                    object['live_auction_start_date_time'].split(',')[0],
                  buyNowPrice: object['reserve_price'],
                  currentPreBid: object['HighestBid'],
                  financing: '--',
                  auctionId: object['auction_id'],
                  productid:
                    Object.keys(object['product_id']).length == null
                      ? ' '
                      : Object.keys(object['product_id']).length,
                  auction_type: object['auction_type'],
                  productinfo: object['ProductInfo'],
                  auctionType: object['auction_type'],
                });
              } else if (getAuctionDate == getCurrentDate) {
                // TODAYS AUCTION or Live Auction
                if (getAuctionStartHourMins <= getCurrentHourMin) {
                  this.allBulkTodaysLiveProductList.push({
                    image:
                      object['BatchImageUrl'] == null
                        ? ''
                        : object['BatchImageUrl'][0]['presigned_url'],
                    carName: object['title'],
                    auctionStartTime:
                      object['live_auction_start_date_time'].split(',')[1],
                    auctionStartDate:
                      object['live_auction_start_date_time'].split(',')[0],
                    buyNowPrice: object['reserve_price'],
                    currentPreBid: object['HighestBid'],
                    financing: '--',
                    auctionId: object['auction_id'],
                    productid:
                      Object.keys(object['product_id']).length == null
                        ? ' '
                        : Object.keys(object['product_id']).length,
                    auction_type: object['auction_type'],
                    productinfo: object['ProductInfo'],
                    auctionType: object['auction_type'],
                    auction_status_id: object['auction_status_id']
                      ? object['auction_status_id']
                      : null,
                  });
                } else if (getAuctionStartHourMins > getCurrentHourMin) {
                  //Today's Future Auction
                  this.todayBulkFutureProductList.push({
                    image:
                      object['BatchImageUrl'] == null
                        ? ''
                        : object['BatchImageUrl'][0]['presigned_url'],
                    carName: object['title'],
                    auctionStartTime:
                      object['live_auction_start_date_time'].split(',')[1],
                    auctionStartDate:
                      object['live_auction_start_date_time'].split(',')[0],
                    buyNowPrice: object['reserve_price'],
                    currentPreBid: object['HighestBid'],
                    financing: '--',
                    auctionId: object['auction_id'],
                    productid:
                      Object.keys(object['product_id']).length == null
                        ? ' '
                        : Object.keys(object['product_id']).length,
                    auction_type: object['auction_type'],
                    productinfo: object['ProductInfo'],
                    auctionType: object['auction_type'],
                  });
                }
              } else if (getAuctionStartHourMins > getCurrentHourMin) {
                this.todayBulkFutureProductList.push({
                  image:
                    object['BatchImageUrl'] == null
                      ? ''
                      : object['BatchImageUrl'][0]['presigned_url'],
                  carName: object['title'],
                  auctionStartTime:
                    object['live_auction_start_date_time'].split(',')[1],
                  auctionStartDate:
                    object['live_auction_start_date_time'].split(',')[0],
                  buyNowPrice: object['reserve_price'],
                  currentPreBid: object['HighestBid'],
                  financing: '--',
                  auctionId: object['auction_id'],
                  productid:
                    Object.keys(object['product_id']).length == null
                      ? ' '
                      : Object.keys(object['product_id']).length,
                  auction_type: object['auction_type'],
                  productinfo: object['ProductInfo'],
                  auctionType: object['auction_type'],
                });
              }
            }
          }
        }
        // }, 1000);
        this.loading = false;
      },
      (error: HttpErrorResponse) => {
        if (error.error.message == 'The incoming token has expired') {
          this.router.navigate(['/']);
        }
      }
    );
  }

  editAuction(auctionId: any, indicator: any, productId: any) {
    localStorage.setItem('auction_id', JSON.stringify(auctionId));
    localStorage.setItem('futureAuctionIndicator', JSON.stringify(indicator));
    localStorage.setItem('product_id', JSON.stringify(productId));
  }

  editBulkAuction(
    auctionId: any,
    indicator: any,
    productId: any,
    productInfo: any
  ) {
    localStorage.setItem('auction_id', JSON.stringify(auctionId));
    localStorage.setItem('futureAuctionIndicator', JSON.stringify(indicator));
    localStorage.setItem('product_id', JSON.stringify(productId));
    localStorage.setItem('product_info_list', JSON.stringify(productInfo));
  }
}
